import React from "react";
import IAction from "models/IAction";
import IStore from "models/IStore";
import { connect, DispatchProp } from "react-redux";
import BaseTable from "views/components/base-table/BaseTable";
import IconNameEnum from "constants/IconNameEnum";
import CercaSimulazioneTabellaModel from "stores/ricerca/models/CercaSimulazioneTabellaModel";
import CercaSimulazioneDettaglio from "./CercaSimulazioneDettaglio";
import BaseIcon from "views/components/base-form/BaseIcon";
import CercaSimulazioneFormModel from "stores/ricerca/models/CercaSimulazioneFormModel";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import CercaAction from "stores/ricerca/CercaAction";
import LoadingIndicator from "views/components/loading-indicator/LoadingIndicator";
import CercaSimulazioneModel from "stores/ricerca/models/CercaSimulazioneModel";
import { ISearchSimulazioneRequest } from "stores/ricerca/CercaEffects";
import FormatUtility from "utilities/FormatUtility";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import SimulazioneStepOneFormModel from "stores/simulazione/models/SimulazioneStepOneFormModel";
import SimulazioneAction from "stores/simulazione/SimulazioneAction";
import CercaDettalgioSimulazioneModel from "stores/ricerca/models/CercaDettalgioSimulazioneModel";
import NavigationUtility from "utilities/NavigationUtility";
import RouteEnum from "constants/RouteEnum";
import DateFormatEnum from "constants/DateFormatEnum";
import LookUpAction from "stores/lookup/LookUpAction";
import SimulazioneStepTwoFormModel from "stores/simulazione/models/SimulazioneStepTwoFormModel";
import SimulazioneModel from "stores/simulazione/models/SimulazioneModel";
import BasePaginationReact from "views/components/base-table/BasePaginationReact";
import environment from "environment";
import StepsUtility from "utilities/StepsUtility";
import EstimateAction from "stores/estimate/EstimateAction";
import CanaliModel from "../../stores/lookup/models/CanaliModel";
import ValidationUtility from "../../utilities/ValidationUtility";
import FunctionEnum from "../../constants/FunctionEnum";
import AgentiProvvModel from "../../stores/lookup/models/AgentiProvvModel";

interface IProps {
    readonly onExportSimulazione: () => void;
}

interface IState {
    readonly openDettaglioPopup: boolean;
    readonly isNavigating: boolean;
}

interface IStateToProps {
    readonly formModel: CercaSimulazioneFormModel;
    readonly isRequesting: boolean;
    readonly cercaSimulazioneResponse: CercaSimulazioneModel;
    readonly formStep1: SimulazioneStepOneFormModel;
    readonly dettaglioSimulazione?: CercaDettalgioSimulazioneModel;
    readonly formValuesStep2: SimulazioneStepTwoFormModel;
    readonly resumedSimulazione: SimulazioneModel;
    readonly canali: CanaliModel[];
    readonly agentiProvv: AgentiProvvModel[];
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    cercaSimulazioneResponse: state.cerca.cercaSimulazioneResponse,
    formModel: state.cerca.cercaSimulazioneForm,
    isRequesting: selectRequesting(state, [
        CercaAction.REQUEST_CERCA_SIMULATION,
        CercaAction.REQUEST_FIND_SIMULATION_BY_ID,
    ]),
    formStep1: state.simulazione.formStep1,
    dettaglioSimulazione: state.cerca.cercaDettalgioSimulazioneModel,
    formValuesStep2: state.simulazione.formStep2,
    resumedSimulazione: state.simulazione.resumedSimulazione,
    canali: state.lookup.canali,
    agentiProvv: state.lookup.agentiProvv,
});

class CercaSimulazioneTabella extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            openDettaglioPopup: false,
            isNavigating: false,
        };
    }
    private hasUnmounted = false;

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    // public shouldComponentUpdate(prevProps: IStateToProps) {
    //     return prevProps.dettaglioSimulazione?.id !== this.props.dettaglioSimulazione?.id
    // }

    private addLoader = async () => {
        this.setState({ isNavigating: true });
    };

    private removeLoader = async () => {
        this.setState({ isNavigating: false });
    };

    private handleRedirectStep2 = async (id: number) => {
        await this.addLoader();
        await this.props.dispatch(CercaAction.dettaglioSimulazioniGet(id));
        await this.props.dispatch(CercaAction.resetDettaglioPreventivo());
        await this.getResumedSimulazione(id);
        await this.handleSimulazioneRedirect();
    };

    private handleSimulazioneRedirect = async () => {
        const { formValuesStep2, dettaglioSimulazione, resumedSimulazione, canali } = this.props;
        if (dettaglioSimulazione?.idAgent) {
            this.props.dispatch(LookUpAction.canaliGet(Number(dettaglioSimulazione?.idAgent)));
        }
        if (dettaglioSimulazione && resumedSimulazione) {
            const step1FormValues = StepsUtility.setStep1FormValues(dettaglioSimulazione, resumedSimulazione, canali);
            // const step1FormValues = new SimulazioneStepOneFormModel({
            //     cliente: dettaglioSimulazione.idAdministrativeCategory.toString(),
            //     idAdministration: dettaglioSimulazione.idAdministration,
            //     amministrazioneCensita: dettaglioSimulazione.idAdministration != null,
            //     amministrazioneNonCensita: dettaglioSimulazione.idAdministration == null,
            //     atc: dettaglioSimulazione.idAdministration
            //         ? dettaglioSimulazione.atc
            //         : dettaglioSimulazione.unregisteredAtcName,
            //     dataNascita: moment(dettaglioSimulazione.birthDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ),
            //     nettoMensile:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     pensioneNettaMensile:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
            //             : undefined,
            //     dataAssunzione:
            //         dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     dataDecorrenza: moment(dettaglioSimulazione.effectiveDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //         DateFormatEnum.ITA_DATE
            //     ), //effective
            //     dataPensionamento:
            //         dettaglioSimulazione.requestType === "CQP"
            //             ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
            //                   DateFormatEnum.ITA_DATE
            //               )
            //             : undefined,
            //     boxOneRata: FormatUtility.numberWithSeparators(
            //         dettaglioSimulazione.payment.toString(),
            //         0.01
            //     )?.toString(),
            //     boxOneDurata: dettaglioSimulazione.duration,
            //     canale: dettaglioSimulazione.idChannel.toString(),
            //     segmento: dettaglioSimulazione.idSegment.toString(),
            //     agente: dettaglioSimulazione.idAgent.toString(),
            //     tipologiaPratica: resumedSimulazione.idPracticeType
            //         ? resumedSimulazione.idPracticeType?.toString()
            //         : environment.defaultIdPracticeType,
            // });

            const step2FormValues = new SimulazioneStepTwoFormModel({
                ...formValuesStep2,
                nome: dettaglioSimulazione.name,
                convenzione: resumedSimulazione.idConvention.toString(),
                fasciaSottoLivelli: resumedSimulazione.idSubLevel
                    ? resumedSimulazione.idSubLevel?.toString()
                    : environment.defaultIdSubLevel,
            });

            const simulazione = new SimulazioneModel({
                idSimulation: dettaglioSimulazione.id,
                idProduct: dettaglioSimulazione.idProduct,
                idInsuranceRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurance,
                idInsurancePriceListRc: dettaglioSimulazione.insurances?.creditRisk?.idInsurancePriceList,
                idInsuranceRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurance,
                idInsurancePriceListRv: dettaglioSimulazione.insurances?.lifeRisk?.idInsurancePriceList,
                idRequestType: dettaglioSimulazione.idRequestedType,
            });

            await this.props.dispatch(SimulazioneAction.setFormStep1(step1FormValues));
            await this.props.dispatch(SimulazioneAction.setFormStep2(step2FormValues));
            await this.props.dispatch(SimulazioneAction.setSimulazioneSalvata(simulazione));
            if (resumedSimulazione.creditoNetInfos !== undefined)
                await this.props.dispatch(SimulazioneAction.setCreditoNetTable(resumedSimulazione.creditoNetInfos));
            if (resumedSimulazione.transferRequestInfos !== undefined)
                await this.props.dispatch(
                    SimulazioneAction.setRichiestaCedibilitaTable(resumedSimulazione.transferRequestInfos)
                );

            await this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    Number(dettaglioSimulazione.idChannel),
                    Number(dettaglioSimulazione.idAgent)
                )
            );

            const durata =
                dettaglioSimulazione.duration && dettaglioSimulazione.duration !== 0
                    ? dettaglioSimulazione.duration.toString()
                    : (dettaglioSimulazione.amount / dettaglioSimulazione.duration).toString();
            const eta = (
                dettaglioSimulazione.duration / 12 +
                new Date().getFullYear() -
                new Date(dettaglioSimulazione.birthDate).getFullYear()
            ).toString();
            const importo = dettaglioSimulazione.amount.toString();
            const rata = dettaglioSimulazione.payment.toString();

            await this.props.dispatch(
                SimulazioneAction.prodottiLightGet(
                    Number(dettaglioSimulazione.idRequestedType),
                    Number(dettaglioSimulazione.idAdministrativeCategory),
                    dettaglioSimulazione.idSegment.toString()!,
                    importo,
                    durata,
                    eta,
                    Number(dettaglioSimulazione.idAgent),
                    dettaglioSimulazione.dipendenteBanca,
                    rata
                )
            ); //TODO: use correct idAggent value
            this.redirectToPage(dettaglioSimulazione.requestType!);
            await this.props.dispatch(SimulazioneAction.setStep(1));
            await this.removeLoader();
        }
    };

    private redirectToPage = async (requestType: string) => {
        switch (requestType) {
            case "CQP":
                NavigationUtility.redirectToPage(RouteEnum.CQP);
                break;
            case "CQS":
                NavigationUtility.redirectToPage(RouteEnum.CQS);
                break;
            case "DLG":
                NavigationUtility.redirectToPage(RouteEnum.DLG);
                break;
        }
    };

    private headers = [
        "Denominazione simulazione",
        "N° simulazione",
        "Tipo richiesta",
        "Tipologia ATC",
        "Agente Produttore",
        "Rata",
        "Durata",
        "Montante",
        "Provvigioni",
        "Saldo",
        "Dettaglio",
    ];

    private getRow = (tabella: CercaSimulazioneTabellaModel, i: number): JSX.Element[] => [
        <>{tabella.name}</>,
        <div
            onClick={() => this.handleRedirectStep2(tabella?.id!)}
            className="cursor-pointer text-ocq-blue font-weight-bold"
        >
            {tabella?.id!}
        </div>,
        <>{tabella.requestType ?? "-"}</>,
        <>{tabella.administrativeCategory ?? "-"}</>,
        <>
            {ValidationUtility.verificaFn(FunctionEnum.FN_BPP)
                ? this.props.agentiProvv.find(
                      (i) => i.idAgent === tabella.idAgent && Number(i.idDipendenteSub) === tabella.idDipendenteSub
                  )?.surname ?? "-"
                : tabella.agent ?? "-"}
        </>,
        <>{FormatUtility.currency(tabella.payment ?? 0)}</>,
        <>{tabella.duration} mesi</>,
        <>{FormatUtility.currency(tabella.amount ?? 0)}</>,
        <>{FormatUtility.currency(tabella.commissions ?? 0)}</>,
        <>{FormatUtility.currency(tabella.balance ?? 0)}</>,
        <BaseIcon icon={IconNameEnum.Documento} />,
    ];

    private handleClick = (data?: CercaSimulazioneTabellaModel) => {
        this.setState({
            openDettaglioPopup: !this.state.openDettaglioPopup,
        });
        this.getDettaglioSimulazione(data?.id || 0);
    };

    private getDettaglioSimulazione = async (id: number) => {
        await this.props.dispatch(CercaAction.dettaglioSimulazioniGet(id));
    };

    private getResumedSimulazione = async (id: number) => {
        await this.props.dispatch(SimulazioneAction.resumeSimulation(id));
        await this.props.dispatch(EstimateAction.resetPreventivo());
    };

    private handleClosePopup = () => {
        this.setState({
            openDettaglioPopup: !this.state.openDettaglioPopup,
        });
    };

    private handlePageChange = async (page?: { selected: number }) => {
        let data = new CercaSimulazioneFormModel({ ...this.props.formModel });

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const request: ISearchSimulazioneRequest = {
            pageNumber: page?.selected! + 1,
            pageSize: 20,
            sortParam: this.props.formModel.colName!,
            sortAsc: this.props.formModel.direction === "A" ? true : false,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            name: data.denominazione ? data.denominazione : undefined,
            creationDateFrom: dataCreazioneDa,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            idAgent: data.agente ? data.agente : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            atc: data.atc ? Number(data.atc) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            instalment: data.rata ? parseFloat(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo) : undefined,
        };
        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.searchSimulation(request));
        }
    };

    private handleTableSort = async (name?: keyof CercaSimulazioneTabellaModel, direction?: undefined | "A" | "D") => {
        let data = new CercaSimulazioneFormModel({ ...this.props.formModel });
        let formValues = new CercaSimulazioneFormModel(this.props.formModel);

        formValues = FormatUtility.updateNestedPropertyValue<CercaSimulazioneFormModel>(formValues, "colName", name!);

        formValues = FormatUtility.updateNestedPropertyValue<CercaSimulazioneFormModel>(
            formValues,
            "direction",
            direction!
        );

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const request: ISearchSimulazioneRequest = {
            pageNumber: this.props.cercaSimulazioneResponse.pageNumber,
            pageSize: 20,
            sortParam: name!,
            sortAsc: direction === "A" ? true : false,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            name: data.denominazione ? data.denominazione : undefined,
            creationDateFrom: dataCreazioneDa,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            idAgent: data.agente ? data.agente : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            atc: data.atc ? Number(data.atc) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            instalment: data.rata ? parseFloat(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo) : undefined,
        };
        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.setCercaSimulazioneForm(formValues));
            await this.props.dispatch(CercaAction.searchSimulation(request));
        }
    };

    public render(): JSX.Element {
        const { openDettaglioPopup, isNavigating } = this.state;
        const { cercaSimulazioneResponse, onExportSimulazione } = this.props;
        return (
            <>
                {this.props.isRequesting || isNavigating ? (
                    <LoadingIndicator className="mb-3" isActive={true} />
                ) : (
                    <>
                        {cercaSimulazioneResponse.data.length > 0 &&
                        cercaSimulazioneResponse.data[0].idSimulation !== 0 ? (
                            <>
                                <Row className="align-items-center pb-3">
                                    <Col sm={12} className="text-right">
                                        <BaseIcon
                                            className="download-excel-icon"
                                            hoverTitle="Scarica Excel"
                                            icon={IconNameEnum.EsportaExcel}
                                            onClick={onExportSimulazione}
                                        />
                                    </Col>
                                </Row>
                                <BaseTable<CercaSimulazioneTabellaModel>
                                    headers={this.headers}
                                    getRow={this.getRow}
                                    items={cercaSimulazioneResponse.data || []}
                                    modelId={"sjsId"}
                                    hideTotal={true}
                                    classNameTh="cq-text-black cq-background-blue"
                                    active={true}
                                    shadow={true}
                                    handleClick={this.handleClick}
                                    pagination={false}
                                    showElementi={false}
                                    borderTabel={false}
                                    cellActiveIndex={10}
                                    headersOrderable={[
                                        { name: "name", orderable: true },
                                        { name: "id", orderable: true },
                                        { name: "requestType", orderable: true },
                                        { name: "administrativeCategory", orderable: true },
                                        { name: "agent", orderable: true },
                                        { name: "payment", orderable: true },
                                        { name: "duration", orderable: true },
                                        { name: "amount", orderable: true },
                                        { name: "commissions", orderable: true },
                                        { name: "balance", orderable: true },
                                    ]}
                                    defaultOrdered={{
                                        colName: this.props.formModel?.colName!,
                                        direction: this.props.formModel.direction,
                                    }}
                                    handleTableSort={this.handleTableSort}
                                />
                            </>
                        ) : (
                            <>
                                {cercaSimulazioneResponse.pageNumber > 0 ? (
                                    <span className="font-weight-bold text-center">Nessun risultato trovato!</span>
                                ) : (
                                    <span className="font-weight-bold text-center">
                                        Avvia la ricerca di una o più simulazioni
                                    </span>
                                )}
                            </>
                        )}
                    </>
                )}
                {cercaSimulazioneResponse.data.length > 0 &&
                    cercaSimulazioneResponse.data[0].idSimulation !== 0 &&
                    isNavigating === false && (
                        <BasePaginationReact
                            pageCount={cercaSimulazioneResponse.totalPages}
                            onPageChange={this.handlePageChange}
                        />
                    )}
                {openDettaglioPopup && (
                    <CercaSimulazioneDettaglio open={openDettaglioPopup} handlePopup={this.handleClosePopup} />
                )}
            </>
        );
    }
}

export { CercaSimulazioneTabella as Unconnected };
export default connect(mapStateToProps)(CercaSimulazioneTabella);
